import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule, TooltipModule } from 'ngx-bootstrap';
import { TagInputModule } from 'ngx-chips';

import { DeleteEntityModule } from 'src/app/shared/delete-entity/delete-entity.module';
import { RecentActivitiesModule } from 'src/app/shared/recent-activities/recent-activities.module';
import { EntityActivitiesModule } from 'src/app/shared/entity-activities/entity-activities.module';

import { TeamMembersPageComponent } from './team-members-page.component';
import { UsersComponent } from './users/users.component';
import { UserCardComponent } from './users/user-card/user-card.component';
import { UserCardActionsModalComponent } from './users/user-card/user-card-actions-modal/user-card-actions-modal.component';
import { ConvertUserToEmployeeComponent } from './users/user-card/convert-user-to-employee/convert-user-to-employee.component';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.teamMembers',
    url: '/teamMembers',
    component: TeamMembersPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      managerObj: null,
      iconClicked: null,
      userType: null,
      fromManagerCard: null
    }
  }
];

@NgModule({
  declarations: [
    TeamMembersPageComponent,
    UsersComponent,
    UserCardComponent,
    UserCardActionsModalComponent,
    ConvertUserToEmployeeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    TagInputModule,
    DeleteEntityModule,
    RecentActivitiesModule,
    EntityActivitiesModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [
    TeamMembersPageComponent,
    UsersComponent,
    UserCardComponent,
    UserCardActionsModalComponent,
    ConvertUserToEmployeeComponent
  ],
  entryComponents: [
    TeamMembersPageComponent,
    UserCardActionsModalComponent
  ]
})
export class TeamMembersPageModule { }
